import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useTable, useGlobalFilter, usePagination, useSortBy } from "react-table";
// import "assets/scss/TableHistorialDesvinculacion.scss"
import { Table, Container, Row, Button, Col } from 'reactstrap';
import { ESTADO_NO_ATENDIDA, functionFormatISODate } from "../../UsuarioGeneral/Solicitud Certificados/Solicitud_Certificados";
import { DatosSolicitudXML, DatosVistaPrevia } from './AnalistaAdministraSolicitudesCertificados';
import SelectItem from 'components/Varios/select';
import ButtonDownloadReportTable from 'components/Varios/ButtonDownloadReportTable';
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion';
import { ParseFechaMesesFromIsoFormat } from 'functions/DatesFunctions';
import { classNameIconoLupa, classNameIconoMensaje } from 'constants/Icons-Font-Awesome';
import { GlobalFilterTable } from 'components/Varios/Tabla/GlobalFilterTable';

type selecttype = {
  label: string,
  value: string
}

type StateModalConfirmar = {
  show: boolean,
  mensajeInicial: string,
  contenido: HTMLElement | undefined
}

const TableSolicitudesCertificadoAnalista = ({ dataprops, onClickVistaPrevia, handleSubirCertificado, handleDescargarCertificado, handleNotificarRoles, anioSeleccionado, onChangeYear, onClickAtender }) => {

  const [valoresColSelect, setvaloresColSelect] = useState<selecttype[]>([])
  const [valoresActualesColSelect, setvaloresActualesColSelect] = useState<selecttype[]>([])
  const [actualizaMulti, setactualizaMulti] = useState<number>(-1)
  const [diferencia, setdiferencia] = useState<selecttype>()

  const initialStateModalConfirmar: StateModalConfirmar = {
    show: false,
    contenido: undefined,
    mensajeInicial: ""
  }
  const [stateModal, setstateModal] = useState<StateModalConfirmar>(initialStateModalConfirmar)

  const data = React.useMemo(
    () => [...dataprops], [dataprops]
  )

  const columns = React.useMemo(
    () => [
      {
        Header: 'Column 1',
        accessor: 'col1', // accessor is the "key" in the data
      },
      {
        Header: 'Column 2',
        accessor: 'col2',
      },
    ],
    [data]
  )


  const GetComponentDatosSolicitudXML = useCallback((value: DatosSolicitudXML | undefined) => {

    if (value && value.usarTodosLosAnios !== undefined) {
      var datos: DatosSolicitudXML = value;
      return (
        <div>
          {
            datos && datos.usarTodosLosAnios &&
            <div>Se deben reflejar todos los años en este certificado </div>
          }
          {
            datos && !datos.usarTodosLosAnios && datos.anioHasta !== undefined && datos.anioHasta > 0 &&
            <div>

              <label>
                Fecha Desde :{datos.anioDesde}
              </label>
              <br />
              <label>
                Fecha Hasta :{datos.anioHasta}
              </label>
            </div>
          }
          {
            datos && !datos.usarTodosLosAnios && datos.anioHasta !== undefined && !(datos.anioHasta > 0) &&
            <label>
              Año deseado para el certificado :{datos.anioDesde}
            </label>
          }
          {
            datos.terminoAcademico && datos.terminoAcademico !== '' &&
            <div>
              <label>
                Termino académico deseado : {`${datos.terminoAcademico === "to" ? "todos" : datos.terminoAcademico}`}
              </label>
            </div>
          }
          {
            datos.cargoContrato !== undefined && datos.cargoContrato !== "" &&
            <div>
              <label>Cargo del contrato deseado : {datos.cargoContrato}</label>
            </div>
          }

        </div>
      )
    }
    else if (value && value.cargoContrato !== undefined && value.cargoContrato !== "") {
      var datos: DatosSolicitudXML = value;
      return (
        <div>
          <label>Cargo del contrato deseado : {datos.cargoContrato}</label>
        </div>)
    }
    else if (value && value.fechaDesde !== undefined && value.fechaHasta !== undefined && value.roles) {
      const { fechaDesde, fechaHasta, roles } = value;

      const contenido: any = value.roles.map((nombresRoles, indiRoles) => {
        return (
          <React.Fragment key={indiRoles + "rolDetalle"}>
            <Row className="justify-content-center">
              <p >{`${indiRoles + 1}.- ${nombresRoles}`}</p>
            </Row>
          </React.Fragment>

        )
      })

      const nuevoEstado: StateModalConfirmar = {
        ...stateModal,
        mensajeInicial: "Detalle de Roles: ",
        show: true,
        contenido
      }

      const formeateadaFechaDesde = ParseFechaMesesFromIsoFormat(fechaDesde);
      const formeateadaFechaHasta = ParseFechaMesesFromIsoFormat(fechaHasta);
      return (
        <div>
          <label className='mb-0'><label className='font-weight-bold mb-0' >Fecha Inicio: </label> {formeateadaFechaDesde}</label>
          <label className='mb-0'><label className='font-weight-bold mb-0' >Fecha Fin: </label> {formeateadaFechaHasta}</label><br />
          <Button style={{ backgroundColor: "#FFC200", float: "none", height: "27px", width: "27px" }} className="m-0 p-1 btn-icono" onClick={() => setstateModal(nuevoEstado)}>
            <i className="fas fa-eye" aria-hidden="true" ></i>
          </Button>
        </div>
      )
    }
    else if (value && value.incluirTipoContrato !== undefined) {
      const { anioInicio, anioFin, incluirTipoContrato } = value;
      return (
        <div>
          <label>Año Inicio :{anioInicio}</label>
          <br />
          <label>Año Fin :{anioFin}</label>
          <label>Incluir tipo contrato : {incluirTipoContrato === true ? 'Si' : 'No'} </label>
        </div>

      )

    }
    else {
      return <div></div>
    }
  }, [stateModal])

  const GetCellAccionTabla = (value: DatosVistaPrevia) => {

    const estilosIconosAcciones: React.CSSProperties = { backgroundColor: "#FFC200", float: "none", height: "27px", width: "27px" };

    const AccionesCell = (listadoBotones: React.ReactElement[]) => {
      return (
        <Row className="justify-content-center rowAccionesFirmaCertificado">
          {
            listadoBotones.map((boton, i) => {
              return (
                <Col key={"colBotonAcciones " + i} md={4}>
                  {boton}
                </Col>

              )
            })
          }
        </Row>
      )
    }

    // <Col md={3}>
    //         <Button
    //           data-toggle="tooltip" data-placement="top" title="Firmar Certificado"
    //           style={estilosIconosAcciones}
    //           className="m-0 p-1 btn-icono"
    //           onClick={() => onClickFirmarCertificado(value)}
    //         >
    //           <i className="fas fa-eye" aria-hidden="true" ></i>
    //         </Button>
    //       </Col>
    //       <Col md={3}>
    //         <Button
    //           data-toggle="tooltip" data-placement="top" title="Reversar Certificado"
    //           style={estilosIconosAcciones}
    //           className="m-0 p-1 btn-icono"
    //           onClick={() => onClickReversarEmisionCertificado(value)}
    //           >
    //             <i className={`${classNameIconoBasura}`} aria-hidden="true" ></i>
    //         </Button>
    //       </Col>

    const BotonAtenderSolicitud: React.ReactElement = (
      <>
        {(value.estadoCertificado === undefined || value.estadoCertificado === null) && value.estadosolicitud === "PE" && (
          <Button
            data-toggle="tooltip" data-placement="top" title="Respuesta a la solicitud del certificado"
            style={estilosIconosAcciones}
            className="m-0 p-1 btn-icono"
            onClick={() => onClickAtender(value)}
          >
            <i className={`${classNameIconoMensaje} hover`} aria-hidden="true"></i>
          </Button>
        )}

      </>
    )

    if (value.automatizado && value.estadosolicitud !== ESTADO_NO_ATENDIDA && (!value.estadoCertificado)) {

      const botonVistaPrevia: React.ReactElement = (
        <Button
          style={estilosIconosAcciones}
          className="m-0 p-1 btn-icono"
          onClick={() => onClickVistaPrevia(value)}
          data-toggle="tooltip" data-placement="top" title="Vista Previa de Certificado"
        >
          <i className={classNameIconoLupa} aria-hidden="true" ></i>
        </Button>
      );

      const listadoAcciones: React.ReactElement[] = [botonVistaPrevia, BotonAtenderSolicitud];

      return (AccionesCell(listadoAcciones))

    }
    else if (!value.automatizado && value.idtipocertificado === 30 && value.estadosolicitud !== "AT") {

      const botonNotificarRoles: React.ReactElement = (
        <Button style={estilosIconosAcciones} className="m-0 p-1 btn-icono"

          data-toggle="tooltip" data-placement="top" title="Notificar a Servidor"
          onClick={() => handleNotificarRoles(value.idsolicitud)}>
          {/* Notificar a Servidor */}
          <i
            className="fa fa-solid fa-bell"
            aria-hidden="true">
          </i>
        </Button>
      )

      const listadoAcciones: React.ReactElement[] = [botonNotificarRoles, BotonAtenderSolicitud];

      return (AccionesCell(listadoAcciones))
    }

    else if (!value.automatizado && value.idtipocertificado === 30 && value.estadosolicitud === "AT") {
      return (<div>Ya se ha notificado al servidor sobre su certificado</div>)
    }
    else if (!value.automatizado && (!value.estadoCertificado) && value.estadosolicitud !== ESTADO_NO_ATENDIDA) {

      const botonSubirCertificado = (
        <Button style={estilosIconosAcciones}
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title="Subir Certificado" className="m-0 p-1 btn-icono" onClick={() => handleSubirCertificado(value)}>
          <i
            className="fa fa-upload download"
            aria-hidden="true">
          </i>
        </Button>
      )

      const listadoAcciones: React.ReactElement[] = [botonSubirCertificado, BotonAtenderSolicitud];

      return (AccionesCell(listadoAcciones))

    }
    else if (value.estadosolicitud === ESTADO_NO_ATENDIDA && !value.referencia) {
      return (<div>La solicitud de certificado ha sido procesada</div>)
    }
    else if (value.estadoCertificado && value.estadoCertificado === "G") {
      return (<div>El certificado está siendo atendido por el Director de TH</div>)
    }
    else if (value.estadoCertificado && value.estadoCertificado === "F" && value.referencia) {
      return (
        <i
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title="Descargar Certificado"
          onClick={() => handleDescargarCertificado(value.referencia)}
          className="fas fa-download download"
          aria-hidden="true">
        </i>
      )
    }
  }


  const columns_usando: any = React.useMemo(
    () => [
      {
        Header: '#',
        accessor: (originalrow, index) => index + 1,
        disableSortBy: true,
      },
      {
        Header: 'F. Solicitud',
        accessor: 'fecs',
        Cell: ({ value }) => {
          var algo = value ? functionFormatISODate(value.toString()) : "";
          return algo;
        }
      },

      {
        Header: "Ident.",
        accessor: "numeroIdentificacion"
      },
      {
        Header: 'Solicitante',
        accessor: 'nom',
      },
      {
        Header: 'Tipo Certificado',
        accessor: 'tip',
      },
      {
        Header: 'Dirigido a',
        accessor: 'dir'
      },
      {
        Header: 'Observaciones',
        accessor: 'obs',

      },
      {
        Header: 'Emitido por',
        accessor: 'analista'
      },
      {
        Header: 'F. Emisión',
        accessor: "fechaanalistaemite",
        Cell: ({ value }) => {
          var algo = value ? functionFormatISODate(value.toString()) : "";
          return algo;
        }
      },
      {
        Header: 'Datos',
        accessor: 'datossol',
        // Cell: ({ value }) => <div></div>
        Cell: ({ value }) => GetComponentDatosSolicitudXML(value)
      },
      {
        Header: 'F. Firma',
        accessor: 'fechafirma',
        Cell: ({ value }) => {
          var algo = value ? functionFormatISODate(value.toString()) : "";
          return algo;
        }
      },
      {
        Header: 'Estado Certificado',
        accessor: 'estc',

      },
      {
        Header: 'Acciones',
        accessor: 'vp',
        Cell: ({ value }) => {
          const accion = GetCellAccionTabla(value)
          return accion;
        }
      },

    ],
    [data]
  )


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    setPageSize,
    visibleColumns,
    prepareRow,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
    state,
    setGlobalFilter,

  } = useTable(
    {
      columns: columns_usando,
      data
    },
    useGlobalFilter,
    useSortBy,
    usePagination

  )
  const sizerows = data.length;


  const { globalFilter, pageIndex, pageSize } = state;

  useEffect(() => {
    if (allColumns.length > 0) {
      var opcionesSelect: selecttype[] = []
      allColumns.map((columns, index) => {
        opcionesSelect.push({ label: columns.Header as string, value: index.toString() })
      })
      setvaloresColSelect(opcionesSelect)
      setvaloresActualesColSelect(opcionesSelect)
    }
  }, [allColumns])


  function HandleStyle(header: string) {
    var s_border = 'solid 1px black'
    var s_background = '#243165'
    var s_color = "white"
    var s_textAlign = "center"
    var s_wordBreak = "break-word"
    var s_width = "auto"

    switch (header) {
      case "#":
        s_width = "50px";
        break;
      case "Observaciones":
        s_width = "250px";
        break;
      case "Acciones":
        s_width = "80px";
        break;
      default:
        break;
    }


    const estilos: React.CSSProperties = {
      border: s_border,
      background: s_background,
      color: s_color,
      textAlign: "center",
      wordBreak: "break-word",
      width: s_width
    }
    return (estilos)

  }

  function handleChangeMultiCols(selectedValues: selecttype[], anterioresValues: selecttype[]) {

    if (!selectedValues) {
      return
    }

    var orderedSelectedValues = [...selectedValues].sort((a, b) => (+a.value) - (+b.value))
    setvaloresActualesColSelect(orderedSelectedValues)

    var diferencia: selecttype | undefined = undefined;
    if (anterioresValues.length > selectedValues.length) {
      diferencia = anterioresValues.find(x => !selectedValues.includes(x))
    }
    else {
      diferencia = selectedValues.find(x => !anterioresValues.includes(x))

    }
    if (diferencia) {
      setdiferencia(diferencia)
    }
    setactualizaMulti(actualizaMulti + 1)

  }

  useEffect(() => {
    if (diferencia && actualizaMulti > -1) {
      var columna = allColumns.find((c) => c.Header === diferencia.label)
      if (columna) {
        if (typeof (columna.toggleHidden) === "function") {
          if (columna.isVisible) {
            columna.toggleHidden(true)

          }
          else {
            columna.toggleHidden(false)
          }
        }
      }
    }
    // if(actualizaMulti > 1 && valoresActualesColSelect.length > 0){      
    //   allColumns.map((column:Column) => {
    //     if(valoresActualesColSelect.find((value) => value === column.Header)  ){
    //       if(typeof(column.toggleHidden) === "function"){
    //         column.toggleHidden(false)
    //       }
    //     }
    //     else{
    //       if(typeof(column.toggleHidden) === "function"){
    //         column.toggleHidden(true)
    //       }
    //     }

    //   })
    // }
  }, [actualizaMulti, valoresActualesColSelect, diferencia])


  const helperClassNamesWidthTable = useCallback(() => {
    const numberVisibleColumns = visibleColumns.length;
    const numeroSmall = 8
    const numeroExtraSmall = 6

    var classNameUsando = "tableHistorialDesvinculacion";
    if (numberVisibleColumns && numberVisibleColumns <= numeroExtraSmall) {
      classNameUsando = "tableHistorialDesvinculacion-xs";

    }
    else if (numberVisibleColumns && numberVisibleColumns > numeroExtraSmall && numberVisibleColumns <= numeroSmall) {
      classNameUsando = "tableHistorialDesvinculacion-sm";
    }
    else if (numberVisibleColumns && numberVisibleColumns > numeroSmall) {
      classNameUsando = "tableHistorialDesvinculacion-lg";

    }
    return classNameUsando;
  },
    [visibleColumns]
  )




  const BotonDescargarReporte = useMemo(
    () => {
      var anioForButton = 0;
      if (anioSeleccionado >= 0) {
        anioForButton = +anioSeleccionado
      }
      return (
        <ButtonDownloadReportTable
          api='SolicitudCertificados/Analista/ReporteSolicitudesCertificados/A'
          nombreBoton='Reporte Solicitudes Certificados'
          apiYears='SolicitudCertificados/Analista/YearsSolicitudes'
          onChangeYear={onChangeYear}
          yearElegido={anioSeleccionado}
          opcionTodos={false}
        />
      )
    }, [anioSeleccionado])

  if (visibleColumns.length > 0) {
    return (
      <React.Fragment>

        <Container className='parentTableHistorial'>
          {/* {
            valoresActualesColSelect.length > 0 &&
            <Row>
              <Col xl={12}>
                {allColumns.map(column => (
                  <div key={column.id}>
                    <label>
                      <input type="checkbox" {...column.getToggleHiddenProps()} />{' '}
                      {column.id}
                    </label>
                  </div>
                ))}
              </Col>
            </Row>
          } */}
          {
            valoresColSelect.length > 0 &&
            <Row>
              <Col xl={12}>
                <SelectItem
                  options={valoresColSelect}
                  value={valoresActualesColSelect}
                  onChange={(values: any) => handleChangeMultiCols(values, valoresActualesColSelect)}
                  placeholder=""
                  name="columnastableselect"
                  id="columnastableselect"
                  icon="fa-caret-right"
                  isMulti={true}
                />
              </Col>
            </Row>
          }



          <Row className="mt-5 mt-md-3 ">
            <Col xl={{ offset: 9, size: 3 }} lg={{ offset: 8, size: 4 }} md={{ offset: 8, size: 4 }} sm={{ offset: 8, size: 4 }}   >
              <GlobalFilterTable
                filter={globalFilter}
                setFilter={setGlobalFilter}

              />
            </Col>
          </Row>


          <Row className="justify-content-end mb-1">
            <Col xl={3} lg={3} md={4} sm={12}>
              {BotonDescargarReporte}
            </Col>
          </Row>

          {/* <Row className="justify-content-end">
            <Col xl={3} lg={3} md={4} sm={12}>
              <ButtonDownloadReportTable
                api='SolicitudCertificados/Analista/ReporteSolicitudesCertificados/A'
                nombreBoton='Reporte Solicitudes Certificados'
                apiYears='SolicitudCertificados/Analista/YearsSolicitudes'
              />
            </Col>
          </Row> */}





          <Row>
            <Col xl={12}>
              <Table responsive {...getTableProps()} style={{ border: 'solid 1px ' }} className={`mt-3 ${helperClassNamesWidthTable()}`}>
                <thead>
                  {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map(column => (
                        <th
                          {...column.getHeaderProps(column.getSortByToggleProps())}
                          style={HandleStyle(column.Header as string)}
                        >
                          {column.render('Header')}
                          <span>
                            {column.isSorted ? (column.isSortedDesc ? '⬆️' : '⬇️') : ''}
                          </span>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {page.map((row, indirow) => {
                    prepareRow(row)
                    return (
                      <tr {...row.getRowProps()}>

                        {row.cells.map(cell => {
                          if (cell.column.Header === '#') {
                            return (
                              <td
                                key="cell#TableSolicCertiEmitFir"
                                style={{
                                  border: 'solid 1px black',

                                }}
                              >{indirow + 1}</td>)
                          }
                          return (
                            <td
                              className={cell.column.Header === "Observaciones" ? 'tdjustify' : "tableHistorialcolumns"}
                              {...cell.getCellProps()}
                              style={{
                                border: 'solid 1px black',

                              }}
                            >
                              <div>
                                {cell.render('Cell')}

                              </div>
                            </td>
                          )
                        })}
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
              <div className="text-right filasinfopagination">
                <span>Mostrando {page.length} de {sizerows} filas</span>
              </div>
              <div className="containerPaginacionHistorial text-right">
                <span>
                  Página{' '}
                  <strong>
                    {pageIndex + 1} de {pageOptions.length}
                  </strong>{' '}
                </span>
                <select
                  value={pageSize}
                  onChange={(e) => setPageSize(Number(e.target.value))}
                >
                  {[5, 10, 15, 25, 50].map((pageSize) => (
                    <option key={pageSize} value={pageSize} >
                      Mostrar {pageSize}
                    </option>
                  ))}
                </select>
                <span className="container-btns-pagination">
                  <button className={canPreviousPage ? "btnAnteriorPaginacion" : "btndisabled"} onClick={() => previousPage()} disabled={!canPreviousPage}>Anterior</button>
                  <button className={canNextPage ? "btnSiguientePaginacion" : "btndisabled"} onClick={() => nextPage()} disabled={!canNextPage} >Siguiente</button>
                </span>
              </div>
            </Col>
          </Row>
        </Container>
        <ModalConfirmacion
          show={stateModal.show}
          onClose={() => setstateModal({ ...stateModal, show: false, contenido: undefined, mensajeInicial: "" })}
          asyncAccion={false}
          asyncClose={false}
          closeAfterAccion={true}
          mensajeConfirmacion={stateModal.mensajeInicial}
          nombreBotonAccion={"Continuar"}
          size="md"
          onClick={() => setstateModal({ ...stateModal, show: false, contenido: undefined, mensajeInicial: "" })}
          hideBotonCerrar={true}
          contentModal={stateModal.contenido}
          tituloModal={"Información Solicitud Certificado"}
          classNameAllModal='modal-detalle-rolesPago'
        />
      </React.Fragment>

    )
  }
  else {
    return (
      <React.Fragment>
        <Container className='parentTableHistorial'>
          {/* {
            valoresActualesColSelect.length > 0 &&
            <Row>
              <Col xl={12}>
                {allColumns.map(column => (
                  <div key={column.id}>
                    <label>
                      <input type="checkbox" {...column.getToggleHiddenProps()} />{' '}
                      {column.id}
                    </label>
                  </div>
                ))}
              </Col>
            </Row>
          } */}
          {
            valoresColSelect.length > 0 &&
            <React.Fragment>
              <Row>
                <Col xl={12}>
                  <SelectItem
                    options={valoresColSelect}
                    value={valoresActualesColSelect}
                    onChange={(values: any) => handleChangeMultiCols(values, valoresActualesColSelect)}
                    placeholder=""
                    name="columnastableselect"
                    id="columnastableselect"
                    icon="fa-caret-right"
                    isMulti={true}
                  />
                </Col>
              </Row>



              <Row>
                <Col xl={12}>
                  <p>Ha ocultado toda la tabla. Muestre una columna para volver a verla.</p>
                </Col>
              </Row>
            </React.Fragment>

          }
        </Container>

      </React.Fragment>
    )
  }


}




export default TableSolicitudesCertificadoAnalista;

